import { get, map, take } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import ColorSwatchButton from 'components/ColorSwatchButton';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import { SWATCH_DIAMETER, N_SWATCHES, SWATCH_TAP_TARGET_DIAMETER } from './constants';
import Upsell from './Upsell';

const CartUpsell = class extends React.PureComponent {
  static propTypes = {
    config: PropTypes.shape({
      cta: PropTypes.string,
    }).isRequired,
    addToCart: PropTypes.func.isRequired,
    recommendedColors: PropTypes.arrayOf(
      PropTypes.shape({
        colors: PropTypes.arrayOf(PropTypes.string),
        fullName: PropTypes.string.isRequired,
      })
    ).isRequired,
    recommendedSizes: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      colorIndex: 0,
    };
  }

  get colors() {
    return take(this.props.recommendedColors, N_SWATCHES);
  }

  get color() {
    return get(this.props.recommendedColors, [this.state.colorIndex]);
  }

  get size() {
    return get(this.props.recommendedSizes, [0]);
  }

  get variant() {
    return get(this.color, ['sizes', this.size]);
  }

  get image() {
    return {
      src: get(this.color, ['defaultImage', 'src']),
      alt: get(this.color, ['fullName']),
    };
  }

  get price() {
    return this.variant.price;
  }

  get headline() {
    return get(this.props.config, ['cta'])
      ? I18n.localize(get(this.props.config, ['cta']))
      : get(this.color, ['masterName']);
  }

  get colorName() {
    return get(this.color, 'colorName');
  }

  get localizedSize() {
    return !this.color.isUnisize ? get(this.variant, 'value') : '';
  }

  get linkUrl() {
    return get(this.color, 'url');
  }

  handleSwatchClick = colorIndex => {
    this.setState({ colorIndex });
  };

  handleAddToCart = () => this.props.addToCart(this.variant.id);

  render() {
    return (
      <Upsell
        headline={this.headline}
        colorName={this.colorName}
        localizedSize={this.localizedSize}
        addToCart={this.handleAddToCart}
        imageSrc={this.image.src}
        imageAlt={this.image.alt}
        price={this.price}
        linkUrl={this.linkUrl}
      >
        <div className="Upsell__swatches">
          {map(this.colors, ({ colors, fullName, swatchImageUrl }, i) => (
            <ColorSwatchButton
              ariaLabel={fullName}
              imageUrl={swatchImageUrl}
              colors={colors}
              onClick={() => this.handleSwatchClick(i)}
              isSelected={i === this.state.colorIndex}
              diameter={SWATCH_DIAMETER}
              key={i}
            />
          ))}
        </div>
        <style jsx>
          {`
            .Upsell__swatches {
              margin-top: ${Theme.get('spacing-px')};
              margin-bottom: ${Theme.get('spacing') * -1}px;
            }
          `}
        </style>
        <style jsx global>
          {`
            .Upsell .ColorSwatchButton {
              width: ${SWATCH_TAP_TARGET_DIAMETER}px;
              height: ${SWATCH_TAP_TARGET_DIAMETER}px;
            }

            .Upsell .ColorSwatchButton:first-child {
              margin-left: ${Theme.get('spacing') * -1}px;
            }
          `}
        </style>
      </Upsell>
    );
  }
};

export default CartUpsell;
